export default function adaptUrl(url) {
  if (!url) return ''
  return url.replace(/http(s?):\/\/www.gocase(.com.br|.com)/, '').trim()
}
